/**
 * Initialize default store products
 * Run this script once to set up the initial store products
 */

import { db } from '@/lib/firebase';
import { collection, addDoc, getDocs, query, where } from 'firebase/firestore';

const defaultProducts = [
  {
    name: 'Beer Mats',
    description: 'Custom branded beer mats for your performances',
    price: 12.99,
    free_claim_threshold_gbp: 12.99,
    image_url: '',
    image_url_2: '',
    order: 0
  },
  {
    name: 'LED QR Sign',
    description: 'LED sign displaying your QR code for easy song requests',
    price: 20.99,
    free_claim_threshold_gbp: 20.99,
    image_url: '',
    image_url_2: '',
    order: 1
  },
  {
    name: 'Roll Up Banner',
    description: 'Professional roll-up banner for your gigs',
    price: 34.99,
    free_claim_threshold_gbp: 34.99,
    image_url: '',
    image_url_2: '',
    order: 2
  }
];

export const initializeStoreProducts = async (force = false) => {
  try {
    console.log('🛒 Initializing store products...');
    
    if (!db) {
      console.error('❌ Firestore database not initialized');
      throw new Error('Firestore database not initialized');
    }
    
    // Check if products already exist
    const productsRef = collection(db, 'store_products');
    const existingProducts = await getDocs(productsRef);
    
    if (!force && existingProducts.docs.length > 0) {
      console.log(`✅ Store products already exist (${existingProducts.docs.length} products). Skipping initialization.`);
      return { success: true, message: 'Products already exist', count: existingProducts.docs.length };
    }
    
    if (force && existingProducts.docs.length > 0) {
      console.log(`⚠️ Products already exist, but force=true. Adding new products anyway.`);
    }
    
    // Add default products
    const addedProducts = [];
    for (const product of defaultProducts) {
      try {
        const docRef = await addDoc(productsRef, {
          ...product,
          created_at: new Date(),
          updated_at: new Date()
        });
        console.log(`✅ Added product: ${product.name} (ID: ${docRef.id})`);
        addedProducts.push({ id: docRef.id, ...product });
      } catch (productError) {
        console.error(`❌ Error adding product ${product.name}:`, productError);
        // Continue with other products even if one fails
      }
    }
    
    console.log(`✅ Store products initialized successfully! Added ${addedProducts.length} products.`);
    return { success: true, message: `Added ${addedProducts.length} products`, count: addedProducts.length, products: addedProducts };
  } catch (error) {
    console.error('❌ Error initializing store products:', error);
    return { success: false, error: error.message };
  }
};

// Auto-initialize when imported (for admin console)
// Removed auto-initialization - will be called manually from AdminStoreManager

